import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
});

// Attach token from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("assetiq_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || "";
    // Ignore 401s from change-password (that's expected when current password is wrong)
    const skipAutoLogout = url.includes("/auth/change-password") || url.includes("/auth/login");
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    const isSuspension = status === 403 && typeof detail === "string" && detail.toLowerCase().includes("suspended");
    if ((status === 401 || isSuspension) && !skipAutoLogout && window.location.pathname !== "/login") {
      if (isSuspension) {
        try { localStorage.setItem("assetiq_logout_reason", detail); } catch { /* ignore */ }
      }
      localStorage.removeItem("assetiq_token");
      localStorage.removeItem("assetiq_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
